window.createDYData = async function (_items = []) {
    try {
        let res = await fetch('/cart.js');
        let data = await res.json();
        let items = [...data.items, ..._items];
        let dyData = items?.map((item) => {
            return {
                productId: item.id,
                quantity: item.quantity,
                itemPrice: (item.price / 100),
            }
        }) || [];
        return [dyData, items]
    } catch (err) {
        // do nothing
    }
}

window.sendDYAddToCartEvent = function (addedItemData, dyData, cartData) {
    try {
        if (dyData.length > 0) {
            
            let addedProduct = cartData?.find((item) => {
                return addedItemData.product_id == item.product_id
            });
            if (!addedProduct) { return }
            let quantityAdded = addedItemData.quantity;
            let moneyValueAdded = ((addedProduct.price * quantityAdded) / 100)
            
            DY.API("event", {
                name: "Add to Cart",
                properties: {
                    dyType: "add-to-cart-v1",
                    value: moneyValueAdded,
                    currency: Shopify.currency.active,
                    productId: addedProduct.id,
                    quantity: quantityAdded,
                    cart: dyData
                }
            });
        }
    } catch (err) {
        // do nothing
    }
}


if (location.href.includes('/cart')) {
    window.addEventListener("DOMContentLoaded",()=>{
        if(document.querySelector('.js-btn--checkout')) {
            document.querySelector('.js-btn--checkout').addEventListener('click',(e) => {
                if (DY) {
                    DY.API("event", {
                    name: "begin_checkout"
                    });
                }
            });
        }
    });
}
